var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_109",
    "data-name": "Rectangle 109",
    width: 24,
    height: 24,
    transform: "translate(-0.333)",
    fill: "#5e5e5e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "instagram",
    transform: "translate(0.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_119",
    "data-name": "Group 119",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_118",
    "data-name": "Group 118",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_117",
    "data-name": "Group 117"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M269.849,282.922a5.787,5.787,0,0,0-1.757-3.709,6.012,6.012,0,0,0-3.982-1.614,78.4,78.4,0,0,0-10.741.12,5.474,5.474,0,0,0-4.7,4.218c-.518,1.846-.415,10.363-.112,12.188a5.493,5.493,0,0,0,4.363,4.738c1.711.441,10.128.383,12.018.08A5.512,5.512,0,0,0,269.7,294.6c.5-1.9.322-9.968.151-11.679m-2,10.85a3.675,3.675,0,0,1-3.455,3.28c-1.749.194-9.574.3-11.2-.158a3.559,3.559,0,0,1-2.7-3.066,73.282,73.282,0,0,1,0-10.956,3.676,3.676,0,0,1,3.442-3.269,76.547,76.547,0,0,1,10.691.045,3.671,3.671,0,0,1,3.271,3.459,77.23,77.23,0,0,1-.045,10.665m-8.679-11.012a5.567,5.567,0,1,0,5.568,5.573,5.562,5.562,0,0,0-5.568-5.573m-.037,9.168a3.6,3.6,0,1,1,3.64-3.588,3.6,3.6,0,0,1-3.64,3.588m7.121-9.376a1.3,1.3,0,1,1-1.289-1.312,1.292,1.292,0,0,1,1.289,1.312",
    transform: "translate(-248.309 -277.477)",
    fill: "#5e5e5e"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramGray);
export default __webpack_public_path__ + "static/media/instagramGray.0f0c1656ffa3abbeec9fd678d985b623.svg";
export { ForwardRef as ReactComponent };